var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Linking } from 'react-native';
import Debug from './Debug';
import { toErrorMessage } from './ErrorHelper';
import { Metric } from '../metrics';
import TENANT_ID from '../config/TenantId';
const TAG = 'AEAInstallCheckError';
const urlScheme = 'aea://';
function isAEAInstalled() {
    return __awaiter(this, void 0, void 0, function* () {
        // detect if AEA is installed on the user's device and return a boolean
        Metric('stepUpAuthAEAInstallationCheckCall', TENANT_ID).put();
        return Linking
            .canOpenURL(urlScheme)
            .then((response) => {
            if (response) {
                Metric('stepUpAuthAEAInstalled', TENANT_ID).put();
            }
            else {
                Metric('stepUpAuthAEANotInstalled', TENANT_ID).put();
            }
            return response;
        })
            .catch((error) => {
            Debug.error(TAG, 'Failed to check AEA installation', toErrorMessage(error));
            Metric('stepUpAuthAEAInstallationCheckError', TENANT_ID, {
                attributes: {
                    error: toErrorMessage(error),
                },
            }).put();
            return false;
        });
    });
}
export { urlScheme, isAEAInstalled };
//# sourceMappingURL=AEAInstallationChecker.js.map